import React, {useState, useEffect} from 'react';
import { useForm } from "react-hook-form";
import { Grid, FormHelperText, TextField, Select, MenuItem, InputLabel, FormControl, Button} from "@material-ui/core";
import ModalConfirm from '../../utils/form/modalConfirmBase';
import { yupResolver } from "@hookform/resolvers/yup";
import { getState } from "../../actions/dummy-actions";
import { editRegionalById, updateRegional } from '../../actions/regional-actions';
import { TextfieldDisabled} from '../../utils/form/textfieldBasic';
import { styles } from '../styles';
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../constants";

import * as yup from "yup";


export const STATE = getState();
const EditRegional = ({id, stateFieldEdit, refresh}) => {

    const isId = id;
    const classes = styles();
    const [activeDisabled, setActiveDisabled] = useState(false);
    const [open, setOpen] = useState(false);
    const [fieldToEdit, setFieldToEdit] = useState(true);
    const [valueName, setValueName] = useState({});
   
    const [informationUser, setInformationUser] = useState({
      code: '',
        name: '',
        status: '',
    }); 

    const [message, setMessage] = useState({
      description : '',
      textButtonSubmit : '',
      handleClick : () => {} ,
      handleClickOut : () => {},
      oneButtons : false,
      type : '',
      open : false
    });

  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
  });

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const handleClickClose = () => {
    setMessage({...message, open: false}); 
    setActiveDisabled(false);
  }

  const handleClickCloseAndRefresh = () => {
    handleClickClose();
    refrescar();
  }

  const cancelConfirm = () => {
    setMessage({
      description : "¿Está seguro que NO desea continuar editando el registro?",
      textButtonSubmit : 'Aceptar',
      handleClick : () => stateFieldEdit(false),
      handleClickOut: () => handleClickClose(),
      type : 'WARNING',
      open : true
  });
  };


  stateFieldEdit(fieldToEdit);

  const schema = yup.object().shape({
    name: yup.string().nullable().required(REQUIRED_MESSAGE).min(4, 'Ingrese mínimo 4 caracteres').max(50, 'Ingrese máximo 50 caracteres'),
    status:  informationUser.status ? null : yup.string().nullable().required(REQUIRED_MESSAGE),
});

  const { register, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(schema),

    mode: "onTouched",
    reValidateMode: "onChange",
  });

  const onSubmit = (info) => {
  setMessage({
    description : "¿Está seguro que desea actualizar el registro? ",
    textButtonSubmit : 'Aceptar',
    handleClick : () => handleClick(info),
    handleClickOut: () => handleClickClose(),
    type : 'WARNING',
    open : true
  });
  }

  const changeState = () => {
      setInformationUser({ ...informationUser, 'status': 'Activo' }); 
      handleClickClose();
    
  }

  const handleOnChange = event => {
    const { name, value } = event.target;
    if(name=== 'status' && value === 'Inactivo' ){
      setMessage({
        description : `Al inactivar se cerrarán las requisiciones asociadas a la regional ${valueName} y las vacantes publicadas a partir de ellas`,
        textButtonSubmit : 'Aceptar',
        handleClick : () => handleClickClose(),
        handleClickOut: () => changeState(),
        type : 'WARNING',
        open : true
      });
     
    };
    setInformationUser({ ...informationUser, [name]: value })
  };

  useEffect(() => {
    const create = async() => {
        const response = await editRegionalById(id);
        setInformationUser({ 
      status: response?.data?.status, });
      setValue('code', response?.data?.code)
      setValue('name', response?.data?.name)
      setValueName( response?.data?.name)
    }
   
        create();
}, [!fieldToEdit])

const refrescar = () =>  {refresh(); setFieldToEdit(false)}

  const handleClick = (data) => {
    setActiveDisabled(true);
    setMessage({...message, open: false}); 
    setOpen(false);
    const body= {
      id: id,
      name: data.name,
      code: data.name,
      status: informationUser.status,
      userEdit: "Developer"
    };
    const edit = async() => {
  
      const resultUpdate = await updateRegional(body);
      if(resultUpdate?.status >= 200 && resultUpdate?.status < 399 ){
          setMessage({
            description : `Regional editada exitosamente`,
            textButtonSubmit : 'Aceptar',
            handleClick : () => handleClickCloseAndRefresh(), 
            type : 'SUCCESS',
            oneButtons: true,
            open : true
          });
         
      } 
      else if(resultUpdate?.status > 399 && resultUpdate?.status !==401 && resultUpdate?.status !== 403){
        setMessage({
          description :  ERROR_MESSAGE,
          textButtonSubmit : 'Aceptar',
          handleClick : () =>  handleClickClose(),
          type : 'WARNING',
          OneButtons : true,
          open : true
        });
      } else {
        setMessage({
          description :  ERROR_MESSAGE,
          textButtonSubmit : 'Aceptar',
          handleClick : () =>  handleClickClose(),
          type : 'WARNING',
          OneButtons : true,
          open : true
        });
      }
    };
      edit();
   closeModal();
     
  }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className={classes.formEdit } autocomplete="off">
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                      <TextField
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          inputRef={register}
                          className={classes.dropdown }
                          label='Nombre'
                          size = 'small'
                          required
                          // onChange={handleOnChange}
                          name='name'
                          error={errors.hasOwnProperty('name') && errors['name'].message}
                          helperText={errors.hasOwnProperty('name') && errors['name'].message}
                      />
                    </FormControl>   
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextfieldDisabled 
                    inputRef={register}
                    label={"Código"}
                    name={"code"}
                    value={informationUser.name}
                />
              </Grid>
              {isId ? 
                <Grid item xs={12} md={6} lg={3} style={{ marginTop: 4 }}>
                    <FormControl variant="outlined" fullWidth error={!!errors.hasOwnProperty("status") && errors["status"].message}>
                <InputLabel htmlFor="outlined-select-estado" >Estado</InputLabel>
                  <Select
                  fullWidth
                  className={classes.dropdown }
                  inputRef={register}
                  label = "Estado"
                  onChange={handleOnChange}
                  value={informationUser.status}
                  name = "status"
                  inputProps = {
                      {
                          name: 'status',
                          id: 'outlined-select-estado',
                      }
                  } >
                  <MenuItem   className={classes.menuItem} key="ACTIVO" value={"Activo"}>Activo</MenuItem>
                  <MenuItem  className={classes.menuItem} key="INACTIVO" value={"Inactivo"}>Inactivo</MenuItem>
                  </Select>
                <FormHelperText >{errors.hasOwnProperty("status") && errors["status"].message}</FormHelperText>
              </FormControl>
                </Grid>
              : null} 
               <Grid item xs={12} sm={12} lg={3}>
               <Button 
                variant='outlined' 
                style = {{backgroundColor: 'transparent', color: '#7EBDCE'}}
                onClick={cancelConfirm} 
                >
                  CANCELAR
                </Button>
                &nbsp;&nbsp;
              <Button 
                disabled = { activeDisabled }
                style = {{backgroundColor: '#7EBDCE', color: '#ffffff', border: '1px solid #e4e1e1 !important'}} 
                type="submit"  
              >
                EDITAR
              </Button>&nbsp;&nbsp;
              <ModalConfirm 
                description = { message.description }
                textButtonSubmit = { message.textButtonSubmit }
                handleClick = { message.handleClick }
                handleClickOut = { message.handleClickOut }
                oneButtons = { message.oneButtons }
                type = { message.type }
                open = { message.open }
              />
            </Grid>
            </Grid>
          </form>
        </>
    )
}

export default EditRegional;